import React from 'react';

// Bandeau de message unifié (erreur / succès) pour les formulaires.
// Remplace les implémentations dupliquées : className="error-message" répété
// à la main, styles inline copiés-collés pour le succès, et la classe
// "success-message" qui n'avait aucun style associé.
const Message = ({ type = 'error', children }) => {
    if (!children) return null;
    return <div className={type === 'success' ? 'success-message' : 'error-message'}>{children}</div>;
};

export default Message;
